<template lang="pug">
//- 「学ぶ」タグ一覧
.libraries
  .tag-h1-area
    .container
      h1._mainttl= "#{{ this.tag.name }}"
  .sub-page-padding
    .container
      ul.columns-block-list.row.row-cols-1.row-cols-sm-2.row-cols-md-3
        li.col(v-for="item,index in libraries") 
          router-link(:to="{name: 'library', params: {id: item.id}}")
            .column-header-block(:style="{ backgroundImage: 'url(' + item.imageUrl + ')' }")
            .column-footer-block
              ul.common-tags-lists
                //- li.common-tags-list.isRead(v-if="item.isRead") {{$t("既読")}}
                //- li.common-tags-list.common-tags-blue.common-tags-color-bg(v-if="item.relType!='ReportArticles'") {{$t(item.relType)}}
              h2.title {{ item.title }}
      .events-readmore-block.center(:class="{ 'hide' : !more }")
        button.middle-button-style.blue-button(@click="readMore") {{$t("もっと見る")}}
</template>

<script>
import { mapState } from 'vuex'
import HeadingBlock from '@/components/HeadingBlock'
import mixinMetaTag from '@/mixins/metaTag.js'

export default {
  name: 'libraryTag',
  components: {
    HeadingBlock,
  },
  mixins: [mixinMetaTag],
  data() {
    return {
      perPage: 9,
    }
  },
  watch: {
    locale() {
      this.load()
    },
  },
  computed: {
    more() {
      return this.length === this.perPage
    },
    ...mapState('libraryTag', { libraries: 'items' }),
    ...mapState('libraryTag', { length: 'length' }),
    ...mapState('libraryTag', { tag: 'tag' }),
    ...mapState(['locale']),
  },
  methods: {
    readMore() {
      this.$store.commit('libraryTag/incrementPage')
      this.load()
    },
    load() {
      this.$store.dispatch('libraryTag/getItems', {
        tagID: this.$route.params.id,
        sortBy: 'newer',
        perPage: this.perPage,
      })
      this.setArticleTitleAsMeta(this.tag.name)
    },
  },
  created() {
    if (!this.libraries.length) {
      this.load()
    } else if (this.tag.id != this.$route.params.id) {
      this.$store.commit('libraryTag/resetItems')
      this.load()
    }
  },
  mounted() {
    this.setArticleTitleAsMeta(this.tag.name)
  },
}
</script>

<style scoped lang="scss">
.columns-block-list {
  margin-top: 32px;
  margin-bottom: 30px;
  > li {
    margin-bottom: 40px;
    a {
      display: block;
      width: 100%;
      height: 100%;
      @include link-hover();
    }
  }
  .column-thumbnail {
    width: 100%;
    display: block;
  }
  .column-header-block {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #f6f6f8;
    width: 100%;
    height: auto;
    padding-top: 56.25%;
  }
  .column-footer-block {
    padding-top: 14px;
  }
  .title {
    margin-top: 9px;
    font-weight: bold;
  }
}
</style>
